// extracted by mini-css-extract-plugin
export default {"container":"styles_container__CUCVk","containerImage":"styles_containerImage__rjwhc","link":"styles_link__B-iw2"};